import { useState } from 'preact/hooks';
import { Knot } from '../components/Knot';
import { SourceCitationChip } from '../components/SourceCitationChip';
import { InterpretationLabel } from '../components/InterpretationLabel';
import { ProposeCard } from '../components/ProposeCard';
import { CapturedConfirmation } from '../components/CapturedConfirmation';
import { AttentionTile, type AttentionSeverity } from '../components/AttentionTile';
import './Kit.css';

const SEVERITIES: AttentionSeverity[] = ['neutral', 'good', 'warning', 'serious', 'critical'];

// Dev-only component gallery (/_kit) — NOT part of the shipped app surface,
// so the section labels below are a deliberate exception to the
// no-instructional-captions rule (that rule governs Today/Auditions/Tapes/
// Money, the actual product; this route exists purely so design review
// doesn't need to hunt through screens for each primitive's states).
export function Kit() {
  const [undone, setUndone] = useState(false);

  return (
    <div class="kit">
      <a class="kit__back" href="#/">
        ← Today
      </a>
      <h1 class="kit__h1">Component gallery</h1>

      <section class="kit__section">
        <div class="kit__label">
          The Knot — idle / listening / understanding / proposing / confirmed / disabled
        </div>
        <div class="kit__row">
          <div class="kit__knot-demo">
            <Knot state="idle" size={48} />
          </div>
          <div class="kit__knot-demo">
            <Knot state="listening" size={48} />
          </div>
          <div class="kit__knot-demo">
            <Knot state="understanding" size={48} />
          </div>
          <div class="kit__knot-demo">
            <Knot state="proposing" size={48} />
          </div>
          <div class="kit__knot-demo">
            <Knot state="confirmed" size={48} />
          </div>
          <div class="kit__knot-demo">
            <Knot state="disabled" size={48} />
          </div>
        </div>
      </section>

      <section class="kit__section">
        <div class="kit__label">SourceCitationChip — live / neutral</div>
        <div class="kit__row">
          <SourceCitationChip glyph="◆" source="live" when="just now" live />
          <SourceCitationChip source="from Layla @ CGF · email" when="Tue 2:14pm" />
        </div>
      </section>

      <section class="kit__section">
        <div class="kit__label">InterpretationLabel — verbatim / interpreted / assumed</div>
        <p class="kit__prose">
          <InterpretationLabel kind="verbatim">3 scenes, memorized</InterpretationLabel> ·{' '}
          <InterpretationLabel kind="interpreted">Self-tape</InterpretationLabel> ·{' '}
          <InterpretationLabel kind="assumed">probably a callback next</InterpretationLabel>
        </p>
      </section>

      <section class="kit__section">
        <div class="kit__label">ProposeCard</div>
        <ProposeCard
          citation={<SourceCitationChip glyph="◆" source="live" when="just now" live />}
          title='New audition — "Riverdale", Guest star'
          meta={
            <>
              <InterpretationLabel kind="interpreted">Self-tape</InterpretationLabel>, due{' '}
              <InterpretationLabel kind="interpreted">Fri 6:00pm</InterpretationLabel> ·{' '}
              <InterpretationLabel kind="verbatim">3 scenes, memorized</InterpretationLabel>
            </>
          }
          fileTarget={
            <>
              File to <b>Auditions</b> · attach the <b>sides PDF</b> from the email
            </>
          }
          onApprove={() => {}}
          onCorrect={() => {}}
          onNotNow={() => {}}
        />
      </section>

      <section class="kit__section">
        <div class="kit__label">CapturedConfirmation (demo state)</div>
        {undone ? (
          <p class="kit__prose">Undone.</p>
        ) : (
          <CapturedConfirmation
            title="Riverdale — due date"
            before="Fri 3:00pm"
            after="Fri 6:00pm"
            onUndo={() => setUndone(true)}
          />
        )}
      </section>

      <section class="kit__section">
        <div class="kit__label">AttentionTile — five severities</div>
        {SEVERITIES.map((severity) => (
          <AttentionTile key={severity} severity={severity} icon="$" title={`${severity} tile`} sub="Example subtext" />
        ))}
      </section>
    </div>
  );
}
